import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiEye } from 'react-icons/fi';

const ViewingCounter = ({ min = 5, max = 50, label = "people are viewing right now" }) => {
    const [count, setCount] = useState(Math.floor(Math.random() * (max - min + 1)) + min);

    useEffect(() => {
        const interval = setInterval(() => {
            // Simulate people jumping in and out
            setCount(prev => {
                const change = Math.floor(Math.random() * 3) - 1; // -1, 0, or 1
                const next = prev + change;
                if (next < min) return min;
                if (next > max) return max;
                return next;
            });
        }, 5000 + Math.random() * 5000); // Random interval between 5-10s

        return () => clearInterval(interval);
    }, [min, max]);

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="inline-flex items-center gap-2 px-4 py-2 bg-primary-light/10 border border-primary-light/20 rounded-full backdrop-blur-sm"
        >
            <div className="relative">
                <FiEye className="text-primary-light w-4 h-4" />
                <span className="absolute -top-1 -right-1 flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-light opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-light"></span>
                </span>
            </div>
            <AnimatePresence mode="wait">
                <motion.span
                    key={count}
                    initial={{ opacity: 0, y: 5 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -5 }}
                    className="text-sm font-medium text-gray-200"
                >
                    <span className="text-primary-light font-bold">{count}</span> {label}
                </motion.span>
            </AnimatePresence>
        </motion.div>
    );
};

export default ViewingCounter;
